import { render, staticRenderFns } from "./StatisticNumber.vue?vue&type=template&id=6f6de3ee&scoped=true"
import script from "./StatisticNumber.vue?vue&type=script&lang=js"
export * from "./StatisticNumber.vue?vue&type=script&lang=js"
import style0 from "./StatisticNumber.vue?vue&type=style&index=0&id=6f6de3ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6de3ee",
  null
  
)

export default component.exports